@if(hasActiveCampaign) {
  @if(!loading) {
    <app-card>
      <h6>{{ title }}</h6>
      <button mat-raised-button class="mw-160" (click)="recieveClickOfferAction('InviteFriends')">{{ 'Intellitrailer.Rental.Screen.btnInvite' | translate : 'Invite' }}</button>
    </app-card>
  
    }
    @else if (loading) {
      <div class="inverted-spinner">
        <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
        <p>{{ 'Intellitrailer.Rental.ReturnComplete.LoadingReturn' | translate : 'Loading...' }}</p>
      </div>
    }
}
